import { formatCurrency, formatMinutes } from '@/lib/format'
import { COST_COLUMN_DIVIDER } from './utilizationClasses'

interface UtilizationTotalRowProps {
  totalMinutes: number
  totalUsd: number
}

/** The receipt's Total. */
export function UtilizationTotalRow({
  totalMinutes,
  totalUsd,
}: UtilizationTotalRowProps) {
  return (
    <tr>
      <td className="pt-3 font-semibold">Total</td>
      <td className="pt-3" />
      <td className={`pt-3 ${COST_COLUMN_DIVIDER} text-right font-semibold`}>
        {formatMinutes(totalMinutes)}
      </td>
      <td className="pt-3" />
      <td className="pt-3 text-right font-bold">{formatCurrency(totalUsd)}</td>
    </tr>
  )
}
